// DevWars — см. .agents/skills/devwars/SKILL.md

import active from './active.json'
import {
  DEV_COUNTRIES,
  DEV_AUTH_USERS,
  DEV_LANGUAGES,
  DEV_DEFAULT_PERSON,
  DEV_ACTIVE_DEFAULT,
} from './countries.mjs'

export function getDevConfig() {
  const code = DEV_COUNTRIES[active.country] ? active.country : 'RU'
  const def = DEV_COUNTRIES[code]
  const isGlobal = Boolean(active.IS_COUNTRY_GLOBAL)

  const fAuth = DEV_AUTH_USERS.some((u) => u.fAuth === active.fAuth)
    ? active.fAuth
    : DEV_ACTIVE_DEFAULT.fAuth

  const person = { ...DEV_DEFAULT_PERSON }
  const override = active.personOverride || {}
  for (const key of ['FIO', 'PHONE', 'EMAIL']) {
    if (override[key] != null && override[key] !== '') {
      person[key] = override[key]
    }
  }

  const curLocation =
    active.curLocation && active.curLocation.CODE
      ? {
          CODE: active.curLocation.CODE,
          ALPHA2: active.curLocation.ALPHA2 || code,
        }
      : {
          CODE: isGlobal ? `${code}_GLOBAL` : code,
          ALPHA2: code,
        }

  const language = active.language || def.language || 'ru'

  return {
    authed: Boolean(fAuth),
    fAuth,
    person,
    IS_COUNTRY_GLOBAL: isGlobal,
    CUR_LOCATION: curLocation,
    currency: def.currency,
    country: { code, name: def.name },
    language,
  }
}

// Локальные биндинги карты (уже импортированы выше для getDevConfig).
export { DEV_COUNTRIES, DEV_AUTH_USERS, DEV_LANGUAGES, DEV_DEFAULT_PERSON }

// Dev-only хелперы окружений НЕ используются в getDevConfig — реэкспортируем
// их формой `export … from`, чтобы Rollup tree-shaking'ом выкинул buildBackendHost
// из prod-бандла (он нужен только dev-панели и vite-плагину).
export {
  DEV_ENV_TYPES,
  DEV_ENV_DEV_MAX,
  DEV_DEFAULT_ENV,
  buildBackendHost,
  isValidEnv,
  normalizeEnv,
} from './countries.mjs'
